import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  VStack,
  Box,
  HStack,
  Input,
  Checkbox,
  Select,
  Textarea,
} from "@chakra-ui/react";
import { AddResultListFrmModalProps, Gender } from "../api/Dtos";
import { useGlobalContext } from "../Layout/GlobalState";

const AddResultListFrmModal: React.FC<AddResultListFrmModalProps> = ({
  isOpen,
  onClose,
  onAddRow,
}) => {
  const globalContext = useGlobalContext();
  const competitionTag = globalContext.competition?.tag ?? null;
  const [name, setName] = useState<string>("");
  const [disciplineName, setDisciplineName] = useState<string>("");
  const [displayOrder, setDisplayOrder] = useState<number>(10);
  const [gender, setGender] = useState<Gender | null>(null);
  const [showResults, setShowResults] = useState<boolean>(false);
  const [earliestBirthYear, setEarliestBirthYear] = useState<number>(0);
  const [latestBirthYear, setLatestBirthYear] = useState<number>(0);

  const handleSubmit = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    if (competitionTag !== null && name.trim().length > 0) {
      onAddRow({
        id: 0,
        competitionTag,
        name: name,
        disciplineName,
        displayOrder,
        gender,
        showResults,
        earliestBirthYear,
        latestBirthYear,
      });
    }

    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={"full"}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Lägg till och specificera en resultatlista</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={10}>
            <Box
              borderRadius={"10px"}
              background={"blue.200"}
              padding={"40px"}
              shadow={"2xl"}
            >
              <Text fontSize={"24px"}>Specificera resultatlistan</Text>
              <HStack spacing={5}>
                <VStack align="left">
                <Text fontSize={"18px"}>Resultatlistans namn</Text>
                <Input
                    minW={100}
                    placeholder="Ange namn på resultatlistan"
                    onChange={(event) => {
                    setName(event.currentTarget.value);
                    }}
                />
                </VStack>
                <VStack align="left">
                <Text fontSize={"18px"}>Sortering (1-100)</Text>
                <Input
                    minW={100} 
                    placeholder="Ange sortering"
                    type="number"
                    onChange={(event) => {
                    const parsed = parseInt(event.currentTarget.value, 10);
                    setDisplayOrder(Number.isNaN(parsed) ? 0 : parsed);
                    }}
                /> 
                </VStack>
                </HStack>
                <HStack spacing={5} align="start">
                <VStack align="left">                
                <Text marginTop={2} fontSize={"18px"}>Klass</Text>
                <Select
                    minW={100}
                    value={disciplineName}
                    onChange={(e) => {
                    setDisciplineName(e.target.value);
                    }}
                >
                    {globalContext.competition?.disciplines.map((c) => {
                    return (
                        <option key={c.id} value={c.name}>
                        {c.name}
                        </option>
                    );
                    })}
                </Select>
                </VStack>
                <VStack align="left">
                <Text marginTop={2} fontSize={"18px"}>Kön</Text>
                <Select
                    minW={100}
                    value={gender == null ? "null" : String(gender)}
                    onChange={(event) => {
                    setGender(
                        event.target.value === "null"
                        ? null
                        : (event.target.value as Gender)
                    );
                    }}
                >
                    <option key={"man"} value={"MAN"}>
                    man
                    </option>
                    <option key={"woman"} value={"WOMAN"}>
                    kvinna
                    </option>                          
                    <option key={"null"} value={"null"}>
                        -
                    </option>
                </Select>
                </VStack>
                <VStack>
                <Text marginTop={2} fontSize={"18px"}>Visa resultat</Text>
                <Checkbox 
                  minW={100}
                  onChange={(event) => {
                    setShowResults(event.currentTarget.checked);
                  }}
                />
                </VStack>                
                </HStack>
                <HStack spacing={5} align="start">                
                <VStack align="left">              
                <Text marginTop={2} fontSize={"18px"}>Född tidigast år (åååå)</Text>
                <Input
                    minW={100}
                    placeholder="Ange tidigaste födelseår"
                    onChange={(event) => {
                        setEarliestBirthYear(parseInt(event.currentTarget.value, 10));
                  }}
                />
                </VStack>
                <VStack align="left">
                  <Text marginTop={2} fontSize={"18px"}>Född senast år (åååå)</Text>
                  <Input
                    minW={100}
                    placeholder="Ange senaste födelseår"
                    onChange={(event) => {
                      setLatestBirthYear(parseInt(event.currentTarget.value, 10));
                    }}
                  />
                </VStack>
                </HStack>
            </Box>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button
            colorScheme="blue"
            mr={3}
            onClick={handleSubmit}
            isDisabled={
              name.trim().length === 0 || competitionTag == null || disciplineName.trim().length === 0
            }
          >
            Lägg till resultatlista
          </Button>
          <Button variant="ghost" onClick={onClose}>
            Avbryt
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddResultListFrmModal;
